<template>
  <span>
    Account Set
  </span>
</template>

<script>
var HasTx = require('../../mixins/has_tx')

export default {
  name   : 'AccountSet',

  mixins : [HasTx]
}
</script>

<style scoped>
</style>
